<template>

  <div class="details">

    <div v-for="col in supportedColumns[resource]" v-bind:key="col['field']">
        <div class="detail">
          <div>
            <img
              class="filter-icon"
              width="16px"
              v-on:click="actionCol(col['label'], col['field'], col['type'])"
              v-bind:class="[ {enabledCol: colEnabled(col['field'])}, {disabledCol: !colEnabled(col['field'])} ]"
              src="../../assets/filter_list_blue_24dp.svg"
            >
            <b>{{ col['label'] }}</b>
          </div>
          <div class="value">
            {{ fieldValue(report, resource, selectedResource, col['field']) }}
          </div>
        </div>
    </div>
    <div class="detail"><h6>Tags</h6>
      <div class="tags" v-for="(value, key) in report[resource][selectedResource]['Tags']" :key="key">
        <div class="tag">
          <img
            class="filter-icon"
            width="16px"
            v-on:click="actionCol(key, 'Tags.' + key, 'string')"
            v-bind:class="[ {enabledCol: colEnabled('Tags.' + key)}, {disabledCol: !colEnabled('Tags.' + key)} ]"
            src="../../assets/filter_list_blue_24dp.svg"
          >
          <b>{{ key }}</b>
        </div>
        <div class="value">
          {{ value }}
        </div>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: 'ResourceDetails',
  props: [
    'report',
    'resource',
    'selectedResource',
    'columns',
    'supportedColumns'
  ],
  data () {
    return {
      loading: false
    }
  },
  methods: {
    actionCol: function (label, field, type) {
      if (this.colEnabled(field)) {
        this.remCol(label, field, type)
      } else {
        this.addCol(label, field, type)
      }
    },
    addCol: function (label, field, type) {
      this.$emit('addCol', {label: label, field: field, type: type})
    },
    remCol: function (label, field, type) {
      this.$emit('remCol', {label: label, field: field, type: type})
    },
    fieldValue: function (report, resource, selectedResource, field) {
      if (field.includes('.')) {
        return report[resource][selectedResource][field.split('.')[0]][field.split('.')[1]]
      } else {
        return report[resource][selectedResource][field]
      }
    },
    colEnabled: function (field) {
      return (this.columns[this.resource].some(e => e.field === field))
    }
  }
}
</script>

<style scoped>
  .details {
    font-size: 12px;
  }
  .detail {
    padding-top: 10px;
  }
  .detail h6 {
    padding-top: 18px;
  }
  .filter-icon {
    margin-right: 5px;
  }
  .filter-icon:hover {
    transition: opacity 200ms;
    opacity: 0.8;
  }
  .value {
    padding-top: 3px;
    padding-left: 25px;
    padding-bottom: 10px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .tags {
    padding-left: 0px;
  }
  .tag {
    padding-top: 10px;
    font-size: 12px;
  }
  .enabledCol {
    cursor: pointer;
    opacity: 1;
    filter: grayscale(0);
  }
  .disabledCol {
    cursor: pointer;
    opacity: 0.6;
    filter: grayscale(1.0);
  }

</style>



// WEBPACK FOOTER //
// src/components/Resources/Details.vue